import React from "react";
import { BoxProps, Stack } from "../../../vanilla";

export const KlarnaPaymentsButton = (props: BoxProps<React.ElementType>) => {
    const { ...rest } = props
    return (
        <Stack
            as={'button'}
            display={'inline-block'}
            className="klarna-sdk-button theme-dark shape-default"
            aria-label="Pay with Klarna"
            style={{ width: '100%' }}
            {...rest}
        >
            <div className="klarna-sdk-button__outline" aria-hidden="true"></div>
            <div className="klarna-sdk-button__inner-container">
                <span className="klarna-sdk-button__text">
                    <span className="klarna-sdk-button-copy">Pay with</span>
                    <span className="klarna-sdk-button-badge" aria-hidden="true"></span>
                    <span className="klarna-sdk-button-text-logo" aria-hidden="true"></span>
                </span>
                <span className="klarna-sdk-button__spinner" aria-hidden="true"></span>
            </div>
        </Stack>
    )
}